import { render } from "./teamSlider.vue?vue&type=template&id=55262dfa&scoped=true"
import script from "./teamSlider.vue?vue&type=script&lang=js"
export * from "./teamSlider.vue?vue&type=script&lang=js"

import "./teamSlider.vue?vue&type=style&index=0&id=55262dfa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55262dfa"]])

export default __exports__